import { IntegrationIcon } from '../IntegrationIcon'
import { getIntegrationDisplayName, type IntegrationServiceId } from '../../common/integrations'
import { type WorkspaceNode } from '../../store/documentConnectors/documentConnectors'
import { WorkspaceSelector } from './WorkspaceSelector'
import styles from './WorkspaceHeaderControl.module.scss'

interface WorkspaceHeaderControlProps {
  serviceId: IntegrationServiceId
  workspaces: WorkspaceNode[]
  workspace: string | null
  onWorkspaceChange: (nodeId: string) => void
}

export const WorkspaceHeaderControl = ({ serviceId, workspaces, workspace, onWorkspaceChange }: WorkspaceHeaderControlProps) =>
  workspaces.length > 0 ? (
    <WorkspaceSelector serviceId={serviceId} workspaces={workspaces} value={workspace} onChange={onWorkspaceChange} />
  ) : (
    <div className={styles.integrationBadge}>
      <IntegrationIcon serviceId={serviceId} width={16} height={16} />
      <span>{getIntegrationDisplayName(serviceId)}</span>
    </div>
  )
